import { render, staticRenderFns } from "./KTabs.vue?vue&type=template&id=70e956dc&"
import script from "./KTabs.vue?vue&type=script&lang=js&"
export * from "./KTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports